var _defineProperty = require("/home/travis/build/Arquisoft/viade_es3c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

// **ShExUtil** provides ShEx utility functions
var ShExUtil = function () {
  var _ShExUtil2;

  var RdfTerm = require("./RdfTerm"); // var util = require('util');


  var Hierarchy = require('hierarchy-closure');

  var SX = {};
  SX._namespace = "http://www.w3.org/ns/shex#";
  ["Schema", "@context", "imports", "startActs", "start", "shapes", "ShapeDecl", "ShapeOr", "ShapeAnd", "shapeExprs", "nodeKind", "NodeConstraint", "iri", "bnode", "nonliteral", "literal", "datatype", "length", "minlength", "maxlength", "pattern", "flags", "mininclusive", "minexclusive", "maxinclusive", "maxexclusive", "totaldigits", "fractiondigits", "values", "ShapeNot", "shapeExpr", "Shape", "abstract", "closed", "extra", "expression", "extends", "restricts", "semActs", "ShapeRef", "reference", "ShapeExternal", "EachOf", "OneOf", "expressions", "min", "max", "annotation", "TripleConstraint", "inverse", "negated", "predicate", "valueExpr", "Inclusion", "include", "Language", "languageTag", "IriStem", "LiteralStem", "LanguageStem", "stem", "IriStemRange", "LiteralStemRange", "LanguageStemRange", "exclusion", "Wildcard", "SemAct", "name", "code", "Annotation", "object"].forEach(function (p) {
    SX[p] = SX._namespace + p;
  });
  var RDF = {};
  RDF._namespace = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
  ["type", "first", "rest", "nil"].forEach(function (p) {
    RDF[p] = RDF._namespace + p;
  });
  var XSD = {};
  XSD._namespace = "http://www.w3.org/2001/XMLSchema#";
  ["anyURI"].forEach(function (p) {
    XSD[p] = XSD._namespace + p;
  });
  var OWL = {};
  OWL._namespace = "http://www.w3.org/2002/07/owl#";
  ["Thing"].forEach(function (p) {
    OWL[p] = OWL._namespace + p;
  });
  var Missed = {}; // singleton

  var UNBOUNDED = -1;

  function extend(base) {
    if (!base) base = {};

    for (var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++) {
      for (var name in arg) {
        base[name] = arg[name];
      }
    }

    return base;
  }

  function isTerm(t) {
    return typeof t !== "object" || "value" in t && Object.keys(t).reduce(function (r, k) {
      return r === false ? r : ["value", "type", "language"].indexOf(k) !== -1;
    }, true);
  }

  function isShapeRef(expr) {
    return typeof expr === "string"; // test for JSON-LD @ID
  }

  var isInclusion = isShapeRef;
  var ShExUtil = (_ShExUtil2 = {
    SX: SX,
    RDF: RDF,
    version: function version() {
      return "0.5.0";
    },
    Visitor: function Visitor() {
      // function expect (l, r) { var ls = JSON.stringify(l), rs = JSON.stringify(r); if (ls !== rs) throw Error(ls+" !== "+rs); }
      var _ShExUtil = this;

      function visitMap(map, val) {
        var ret = {};
        Object.keys(map).forEach(function (item) {
          ret[item] = val(map[item]);
        });
        return ret;
      }

      var r = {
        runtimeError: function runtimeError(e) {
          throw e;
        },
        visitSchema: function visitSchema(schema) {
          var ret = {
            type: "Schema"
          };

          _ShExUtil._expect(schema, "type", "Schema");

          this._maybeSet(schema, ret, "Schema", ["@context", "prefixes", "base", "imports", "startActs", "start", "shapes"], ["_base", "_prefixes", "_index", "_sourceMap"]);

          return ret;
        },
        visitPrefixes: function visitPrefixes(prefixes) {
          return prefixes === undefined ? undefined : visitMap(prefixes, function (val) {
            return val;
          });
        },
        visitIRI: function visitIRI(i) {
          return i;
        },
        visitImports: function visitImports(imports) {
          var _Visitor = this;

          return imports.map(function (imp) {
            return _Visitor.visitIRI(imp);
          });
        },
        visitStartActs: function visitStartActs(startActs) {
          var _Visitor = this;

          return startActs === undefined ? undefined : startActs.map(function (act) {
            return _Visitor.visitSemAct(act);
          });
        },
        visitSemActs: function visitSemActs(semActs) {
          var _Visitor = this;

          if (semActs === undefined) return undefined;
          var ret = [];
          Object.keys(semActs).forEach(function (label) {
            ret.push(_Visitor.visitSemAct(semActs[label], label));
          });
          return ret;
        },
        visitSemAct: function visitSemAct(semAct, label) {
          var ret = {
            type: "SemAct"
          };

          _ShExUtil._expect(semAct, "type", "SemAct");

          this._maybeSet(semAct, ret, "SemAct", ["name", "code"]);

          return ret;
        },
        visitShapes: function visitShapes(shapes) {
          var _Visitor = this;

          if (shapes === undefined) return undefined;
          return shapes.map(function (shapeExpr) {
            return _Visitor.visitShapeDecl(shapeExpr);
          });
        },
        visitProductions999: function visitProductions999(productions) {
          // !! DELETE
          var _Visitor = this;

          if (productions === undefined) return undefined;
          var ret = {};
          Object.keys(productions).forEach(function (label) {
            ret[label] = _Visitor.visitExpression(productions[label], label);
          });
          return ret;
        },
        visitShapeDecl: function visitShapeDecl(decl, label) {
          return decl.type === "ShapeDecl" ? this._maybeSet(decl, {
            type: "ShapeDecl"
          }, "ShapeDecl", ["id", "abstract", "restricts", "shapeExpr"]) : this.visitShapeExpr(decl, label);
        },
        visitShapeExpr: function visitShapeExpr(expr, label) {
          if (isShapeRef(expr)) return this.visitShapeRef(expr);
          var r = expr.type === "Shape" ? this.visitShape(expr, label) : expr.type === "NodeConstraint" ? this.visitNodeConstraint(expr, label) : expr.type === "ShapeAnd" ? this.visitShapeAnd(expr, label) : expr.type === "ShapeOr" ? this.visitShapeOr(expr, label) : expr.type === "ShapeNot" ? this.visitShapeNot(expr, label) : expr.type === "ShapeExternal" ? this.visitShapeExternal(expr) : null; // if (expr.type === "ShapeRef") r = 0; // console.warn("visitShapeExpr:", r);

          if (r === null) throw Error("unexpected shapeExpr type: " + expr.type);else return r;
        },
        // _visitShapeGroup: visit a grouping expression (shapeAnd, shapeOr)
        _visitShapeGroup: function _visitShapeGroup(expr, label) {
          this._testUnknownAttributes(expr, ["id", "shapeExprs"], expr.type, this.visitShapeNot);

          var _Visitor = this;

          var r = {
            type: expr.type
          };
          if ("id" in expr) r.id = expr.id;
          r.shapeExprs = expr.shapeExprs.map(function (nested) {
            return _Visitor.visitShapeExpr(nested, label);
          });
          return r;
        },
        // _visitShapeNot: visit negated shape
        visitShapeNot: function visitShapeNot(expr, label) {
          this._testUnknownAttributes(expr, ["id", "shapeExpr"], "ShapeNot", this.visitShapeNot);

          var r = {
            type: expr.type
          };
          if ("id" in expr) r.id = expr.id;
          r.shapeExpr = this.visitShapeExpr(expr.shapeExpr, label);
          return r;
        },
        // ### `visitNodeConstraint` deep-copies the structure of a shape
        visitShape: function visitShape(shape, label) {
          var ret = {
            type: "Shape"
          };

          _ShExUtil._expect(shape, "type", "Shape");

          this._maybeSet(shape, ret, "Shape", ["id", "abstract", "extends", "closed", "expression", "extra", "semActs", "annotations"]);

          return ret;
        },
        _visitShapeExprList: function _visitShapeExprList(ext) {
          var _Visitor = this;

          return ext.map(function (t) {
            return _Visitor.visitShapeExpr(t, undefined);
          });
        },
        // ### `visitNodeConstraint` deep-copies the structure of a shape
        visitNodeConstraint: function visitNodeConstraint(shape, label) {
          var ret = {
            type: "NodeConstraint"
          };

          _ShExUtil._expect(shape, "type", "NodeConstraint");

          this._maybeSet(shape, ret, "NodeConstraint", ["id", // "abstract", "extends", "restricts", -- futureWork
          "nodeKind", "datatype", "pattern", "flags", "length", "reference", "minlength", "maxlength", "mininclusive", "minexclusive", "maxinclusive", "maxexclusive", "totaldigits", "fractiondigits", "values", "annotations", "semActs"]);

          return ret;
        },
        visitShapeRef: function visitShapeRef(reference) {
          if (typeof reference !== "string") {
            var ex = Exception("visitShapeRef expected a string, not " + JSON.stringify(reference));
            console.warn(ex);
            throw ex;
          }

          return reference;
        },
        visitShapeExternal: function visitShapeExternal(expr) {
          this._testUnknownAttributes(expr, ["id"], "ShapeExternal", this.visitShapeNot);

          return extend("id" in expr ? {
            id: expr.id
          } : {}, {
            type: "ShapeExternal"
          });
        },
        // _visitGroup: visit a grouping expression (someOf or eachOf)
        _visitGroup: function _visitGroup(expr, type) {
          var _Visitor = this;

          var r = Object.assign( // pre-declare an id so it sorts to the top
          "id" in expr ? {
            id: null
          } : {}, {
            type: expr.type
          });
          r.expressions = expr.expressions.map(function (nested) {
            return _Visitor.visitExpression(nested);
          });
          return this._maybeSet(expr, r, "expr", ["id", "min", "max", "onShapeExpression", "annotations", "semActs"], ["expressions"]);
        },
        visitTripleConstraint: function visitTripleConstraint(expr) {
          return this._maybeSet(expr, Object.assign( // pre-declare an id so it sorts to the top
          "id" in expr ? {
            id: null
          } : {}, {
            type: "TripleConstraint"
          }), "TripleConstraint", ["id", "inverse", "predicate", "valueExpr", "min", "max", "onShapeExpression", "annotations", "semActs"]);
        },
        visitExpression: function visitExpression(expr) {
          if (typeof expr === "string") return this.visitInclusion(expr);
          var r = expr.type === "TripleConstraint" ? this.visitTripleConstraint(expr) : expr.type === "OneOf" ? this.visitOneOf(expr) : expr.type === "EachOf" ? this.visitEachOf(expr) : null;
          if (r === null) throw Error("unexpected expression type: " + expr.type);else return r;
        },
        visitValues: function visitValues(values) {
          var _Visitor = this;

          return values.map(function (t) {
            return isTerm(t) || t.type === "Language" ? t : _Visitor.visitStemRange(t);
          });
        },
        visitStemRange: function visitStemRange(t) {
          var _Visitor = this; // console.log(Error(t.type).stack);
          // _ShExUtil._expect(t, "type", "IriStemRange");


          if (!("type" in t)) _Visitor.runtimeError(Error("expected " + JSON.stringify(t) + " to have a 'type' attribute."));
          var stemRangeTypes = ["IriStem", "LiteralStem", "LanguageStem", "IriStemRange", "LiteralStemRange", "LanguageStemRange"];
          if (stemRangeTypes.indexOf(t.type) === -1) _Visitor.runtimeError(Error("expected type attribute '" + t.type + "' to be in '" + stemRangeTypes + "'."));
          var stem;

          if (isTerm(t)) {
            _ShExUtil._expect(t.stem, "type", "Wildcard");

            stem = {
              type: t.type,
              stem: {
                type: "Wildcard"
              }
            };
          } else {
            stem = {
              type: t.type,
              stem: t.stem
            };
          }

          if (t.exclusions) {
            stem.exclusions = t.exclusions.map(function (c) {
              return _Visitor.visitExclusion(c);
            });
          }

          return stem;
        },
        visitExclusion: function visitExclusion(c) {
          if (!isTerm(c)) {
            // _ShExUtil._expect(c, "type", "IriStem");
            if (!("type" in c)) _Visitor.runtimeError(Error("expected " + JSON.stringify(c) + " to have a 'type' attribute."));
            var stemTypes = ["IriStem", "LiteralStem", "LanguageStem"];
            if (stemTypes.indexOf(c.type) === -1) _Visitor.runtimeError(Error("expected type attribute '" + c.type + "' to be in '" + stemTypes + "'."));
            return {
              type: c.type,
              stem: c.stem
            };
          } else {
            return c;
          }
        },
        visitInclusion: function visitInclusion(inclusion) {
          if (typeof inclusion !== "string") {
            var ex = Exception("visitInclusion expected a string, not " + JSON.stringify(inclusion));
            console.warn(ex);
            throw ex;
          }

          return inclusion;
        },
        _maybeSet: function _maybeSet(obj, ret, context, members, ignore) {
          var _Visitor = this;

          this._testUnknownAttributes(obj, ignore ? members.concat(ignore) : members, context, this._maybeSet);

          members.forEach(function (member) {
            var methodName = "visit" + member.charAt(0).toUpperCase() + member.slice(1);

            if (member in obj) {
              var f = _Visitor[methodName];

              if (typeof f !== "function") {
                throw Error(methodName + " not found in Visitor");
              }

              var t = f.call(_Visitor, obj[member]);

              if (t !== undefined) {
                ret[member] = t;
              }
            }
          });
          return ret;
        },
        _visitValue: function _visitValue(v) {
          return v;
        },
        _visitList: function _visitList(l) {
          return l.slice();
        },
        _testUnknownAttributes: function _testUnknownAttributes(obj, expected, context, captureFrame) {
          var unknownMembers = Object.keys(obj).reduce(function (ret, k) {
            return k !== "type" && expected.indexOf(k) === -1 ? ret.concat(k) : ret;
          }, []);

          if (unknownMembers.length > 0) {
            var e = Error("unknown propert" + (unknownMembers.length > 1 ? "ies" : "y") + ": " + unknownMembers.map(function (p) {
              return "\"" + p + "\"";
            }).join(",") + " in " + context + ": " + JSON.stringify(obj));
            Error.captureStackTrace(e, captureFrame);
            throw e;
          }
        }
      };
      r.visitBase = r.visitStart = r.visitVirtual = r.visitClosed = r["visit@context"] = r._visitValue;
      r.visitRestricts = r.visitExtends = r._visitShapeExprList;
      r.visitExtra = r.visitAnnotations = r._visitList;
      r.visitAbstract = r.visitInverse = r.visitPredicate = r._visitValue;
      r.visitName = r.visitId = r.visitCode = r.visitMin = r.visitMax = r._visitValue;
      r.visitType = r.visitNodeKind = r.visitDatatype = r.visitPattern = r.visitFlags = r.visitLength = r.visitMinlength = r.visitMaxlength = r.visitMininclusive = r.visitMinexclusive = r.visitMaxinclusive = r.visitMaxexclusive = r.visitTotaldigits = r.visitFractiondigits = r._visitValue;
      r.visitOneOf = r.visitEachOf = r._visitGroup;
      r.visitShapeAnd = r.visitShapeOr = r._visitShapeGroup;
      r.visitInclude = r._visitValue;
      r.visitValueExpr = r.visitOnShapeExpression = r.visitShapeExpr;
      return r;
    },
    // tests
    // console.warn("HERE:", ShExJtoAS({"type":"Schema","shapes":[{"id":"http://all.example/S1","type":"Shape","expression":
    //  { "id":"http://all.example/S1e", "type":"EachOf","expressions":[ ] },
    // // { "id":"http://all.example/S1e","type":"TripleConstraint","predicate":"http://all.example/p1"},
    // "extra":["http://all.example/p3","http://all.example/p1","http://all.example/p2"]
    // }]}).shapes['http://all.example/S1']);
    ShExJtoAS: function ShExJtoAS(schema) {
      var _ShExUtil = this;

      schema._prefixes = schema.prefixes || {};
      schema._index = this.index(schema);
      return schema;
    },
    AStoShExJ: function AStoShExJ(schema, abbreviate) {
      schema["@context"] = schema["@context"] || "http://www.w3.org/ns/shex.jsonld";
      delete schema["_index"];
      delete schema["_prefixes"];
      return schema;
    },
    ShExRVisitor: function ShExRVisitor(knownShapeExprs) {
      var v = ShExUtil.Visitor();
      var knownExpressions = {};
      var oldVisitShapeExpr = v.visitShapeExpr,
          oldVisitValueExpr = v.visitValueExpr,
          oldVisitExpression = v.visitExpression;
      v.keepShapeExpr = oldVisitShapeExpr;

      v.visitShapeExpr = v.visitValueExpr = function (expr, label) {
        if (typeof expr === "string") return expr;

        if ("id" in expr) {
          if (knownShapeExprs.indexOf(expr.id) !== -1 || Object.keys(expr).length === 1) return expr.id;
          delete expr.id;
        }

        return oldVisitShapeExpr.call(this, expr, label);
      };

      v.visitExpression = function (expr) {
        if (typeof expr === "string") // shortcut for recursive references e.g. 1Include1 and ../doc/TODO.md
          return expr;

        if ("id" in expr) {
          if (expr.id in knownExpressions) {
            knownExpressions[expr.id].refCount++;
            return expr.id;
          }
        }

        var ret = oldVisitExpression.call(this, expr); // Everything from RDF has an ID, usually a BNode.

        knownExpressions[expr.id] = {
          refCount: 1,
          expr: ret
        };
        return ret;
      };

      v.cleanIds = function () {
        for (var k in knownExpressions) {
          var known = knownExpressions[k];
          if (known.refCount === 1 && RdfTerm.isBlank(known.expr.id)) delete known.expr.id;
        }

        ;
      };

      return v;
    },
    // tests
    // var shexr = ShExUtil.ShExRtoShExJ({ "type": "Schema", "shapes": [
    //   { "id": "http://a.example/S1", "type": "Shape",
    //     "expression": {
    //       "type": "TripleConstraint", "predicate": "http://a.example/p1",
    //       "valueExpr": {
    //         "type": "ShapeAnd", "shapeExprs": [
    //           { "type": "NodeConstraint", "nodeKind": "bnode" },
    //           { "id": "http://a.example/S2", "type": "Shape",
    //             "expression": {
    //               "type": "TripleConstraint", "predicate": "http://a.example/p2" } }
    //           //            "http://a.example/S2"
    //         ] } } },
    //   { "id": "http://a.example/S2", "type": "Shape",
    //     "expression": {
    //       "type": "TripleConstraint", "predicate": "http://a.example/p2" } }
    // ] });
    // console.warn("HERE:", shexr.shapes[0].expression.valueExpr);
    // ShExUtil.ShExJtoAS(shexr);
    // console.warn("THERE:", shexr.shapes["http://a.example/S1"].expression.valueExpr);
    ShExRtoShExJ: function ShExRtoShExJ(schema) {
      // compile a list of known shapeExprs
      var knownShapeExprs = [];
      if ("shapes" in schema) knownShapeExprs = knownShapeExprs.concat(schema.shapes.map(function (sh) {
        return sh.id;
      })); // normalize references to those shapeExprs

      var v = this.ShExRVisitor(knownShapeExprs);
      if ("start" in schema) schema.start = v.visitShapeExpr(schema.start);
      if ("shapes" in schema) schema.shapes = schema.shapes.map(function (sh) {
        return sh.type === SX.ShapeDecl ? {
          type: "ShapeDecl",
          id: sh.id,
          abstract: sh.abstract,
          shapeExpr: v.visitShapeExpr(sh.shapeExpr)
        } : v.keepShapeExpr(sh);
      }); // remove extraneous BNode IDs

      v.cleanIds();
      return schema;
    },
    valGrep: function valGrep(obj, type, f) {
      var _ShExUtil = this;

      var ret = [];

      for (var i in obj) {
        var o = obj[i];

        if (typeof o === "object") {
          if ("type" in o && o.type === type) ret.push(f(o));
          ret.push.apply(ret, _ShExUtil.valGrep(o, type, f));
        }
      }

      return ret;
    },
    n3jsToTurtle: function n3jsToTurtle(res) {
      function termToLex(node) {
        return typeof node === "object" ? "\"" + node.value + "\"" + ("type" in node ? "^^<" + node.type + ">" : "language" in node ? "@" + node.language : "") : RdfTerm.isIRI(node) ? "<" + node + ">" : RdfTerm.isBlank(node) ? node : "???";
      }

      return this.valGrep(res, "TestedTriple", function (t) {
        return ["subject", "predicate", "object"].map(function (k) {
          return termToLex(t[k]);
        }).join(" ") + " .";
      });
    },
    valToN3js: function valToN3js(res) {
      return this.valGrep(res, "TestedTriple", function (t) {
        var ret = JSON.parse(JSON.stringify(t));
        if (typeof t.object === "object") ret.object = "\"" + t.object.value + "\"" + ("type" in t.object ? "^^" + t.object.type : "language" in t.object ? "@" + t.object.language : "");
        return ret;
      });
    }
  }, _defineProperty(_ShExUtil2, "n3jsToTurtle", function n3jsToTurtle(n3js) {
    function termToLex(node) {
      if (RdfTerm.isIRI(node)) return "<" + node + ">";
      if (RdfTerm.isBlank(node)) return node;
      var t = RdfTerm.getLiteralType(node);
      if (t && t !== "http://www.w3.org/2001/XMLSchema#string") return "\"" + RdfTerm.getLiteralValue(node) + "\"" + "^^<" + t + ">";
      return node;
    }

    return n3js.map(function (t) {
      return ["subject", "predicate", "object"].map(function (k) {
        return termToLex(t[k]);
      }).join(" ") + " .";
    });
  }), _defineProperty(_ShExUtil2, "index", function index(schema) {
    var index = {
      shapeExprs: new Map(),
      tripleExprs: new Map()
    };
    var v = ShExUtil.Visitor();
    var oldVisitExpression = v.visitExpression;

    v.visitExpression = function (expression) {
      if (typeof expression === "object" && "id" in expression) index.tripleExprs[expression.id] = expression;
      return oldVisitExpression.call(v, expression);
    };

    var oldVisitShapeExpr = v.visitShapeExpr;

    v.visitShapeExpr = v.visitValueExpr = function (shapeExpr, label) {
      if (typeof shapeExpr === "object" && "id" in shapeExpr) index.shapeExprs[shapeExpr.id] = shapeExpr;
      return oldVisitShapeExpr.call(v, shapeExpr, label);
    };

    var oldVisitShapeDecl = v.visitShapeDecl;

    v.visitShapeDecl = v.visitValueExpr = function (shapeExpr, label) {
      if (typeof shapeExpr === "object" && "id" in shapeExpr) index.shapeExprs[shapeExpr.id] = shapeExpr;
      return oldVisitShapeDecl.call(v, shapeExpr, label);
    };

    v.visitSchema(schema);
    return index;
  }), _defineProperty(_ShExUtil2, "canonicalize", function canonicalize(schema, trimIRI) {
    var ret = JSON.parse(JSON.stringify(schema));
    ret["@context"] = ret["@context"] || "http://www.w3.org/ns/shex.jsonld";
    delete ret._prefixes;
    delete ret._base;
    var index = ret._index || this.index(schema);
    delete ret._index;
    var sourceMap = ret._sourceMap;
    delete ret._sourceMap; // Don't delete ret.productions as it's part of the AS.

    var v = ShExUtil.Visitor();
    var knownExpressions = [];
    var oldVisitInclusion = v.visitInclusion,
        oldVisitExpression = v.visitExpression;

    v.visitInclusion = function (inclusion) {
      if (knownExpressions.indexOf(inclusion) === -1 && inclusion in index.tripleExprs) {
        knownExpressions.push(inclusion);
        return oldVisitExpression.call(v, index.tripleExprs[inclusion]);
      }

      return oldVisitInclusion.call(v, inclusion);
    };

    v.visitExpression = function (expression) {
      if (typeof expression === "object" && "id" in expression) {
        if (knownExpressions.indexOf(expression.id) === -1) {
          knownExpressions.push(expression.id);
          return oldVisitExpression.call(v, index.tripleExprs[expression.id]);
        }

        return expression.id; // Inclusion
      }

      return oldVisitExpression.call(v, expression);
    };

    if (trimIRI) {
      v.visitIRI = function (i) {
        return i.replace(trimIRI, "");
      };

      if ("imports" in ret) ret.imports = v.visitImports(ret.imports);
    }

    if ("shapes" in ret) {
      ret.shapes = Object.keys(index.shapeExprs).sort().map(function (k) {
        if ("extra" in index.shapeExprs[k]) index.shapeExprs[k].extra.sort();
        return v.visitShapeDecl(index.shapeExprs[k]);
      });
    }

    return ret;
  }), _defineProperty(_ShExUtil2, "BiDiClosure", function BiDiClosure() {
    return {
      needs: {},
      neededBy: {},
      inCycle: [],
      test: function test() {
        function expect(l, r) {
          var ls = JSON.stringify(l),
              rs = JSON.stringify(r);
          if (ls !== rs) throw Error(ls + " !== " + rs);
        } // this.add(1, 2); expect(this.needs, { 1:[2]                     }); expect(this.neededBy, { 2:[1]                     });
        // this.add(3, 4); expect(this.needs, { 1:[2], 3:[4]              }); expect(this.neededBy, { 2:[1], 4:[3]              });
        // this.add(2, 3); expect(this.needs, { 1:[2,3,4], 2:[3,4], 3:[4] }); expect(this.neededBy, { 2:[1], 3:[2,1], 4:[3,2,1] });


        this.add(2, 3);
        expect(this.needs, {
          2: [3]
        });
        expect(this.neededBy, {
          3: [2]
        });
        this.add(1, 2);
        expect(this.needs, {
          1: [2, 3],
          2: [3]
        });
        expect(this.neededBy, {
          3: [2, 1],
          2: [1]
        });
        this.add(1, 3);
        expect(this.needs, {
          1: [2, 3],
          2: [3]
        });
        expect(this.neededBy, {
          3: [2, 1],
          2: [1]
        });
        this.add(3, 4);
        expect(this.needs, {
          1: [2, 3, 4],
          2: [3, 4],
          3: [4]
        });
        expect(this.neededBy, {
          3: [2, 1],
          2: [1],
          4: [3, 2, 1]
        });
        this.add(6, 7);
        expect(this.needs, {
          6: [7],
          1: [2, 3, 4],
          2: [3, 4],
          3: [4]
        });
        expect(this.neededBy, {
          7: [6],
          3: [2, 1],
          2: [1],
          4: [3, 2, 1]
        });
        this.add(5, 6);
        expect(this.needs, {
          5: [6, 7],
          6: [7],
          1: [2, 3, 4],
          2: [3, 4],
          3: [4]
        });
        expect(this.neededBy, {
          7: [6, 5],
          6: [5],
          3: [2, 1],
          2: [1],
          4: [3, 2, 1]
        });
        this.add(5, 7);
        expect(this.needs, {
          5: [6, 7],
          6: [7],
          1: [2, 3, 4],
          2: [3, 4],
          3: [4]
        });
        expect(this.neededBy, {
          7: [6, 5],
          6: [5],
          3: [2, 1],
          2: [1],
          4: [3, 2, 1]
        });
        this.add(7, 8);
        expect(this.needs, {
          5: [6, 7, 8],
          6: [7, 8],
          7: [8],
          1: [2, 3, 4],
          2: [3, 4],
          3: [4]
        });
        expect(this.neededBy, {
          7: [6, 5],
          6: [5],
          8: [7, 6, 5],
          3: [2, 1],
          2: [1],
          4: [3, 2, 1]
        });
        this.add(4, 5);
        expect(this.needs, {
          1: [2, 3, 4, 5, 6, 7, 8],
          2: [3, 4, 5, 6, 7, 8],
          3: [4, 5, 6, 7, 8],
          4: [5, 6, 7, 8],
          5: [6, 7, 8],
          6: [7, 8],
          7: [8]
        });
        expect(this.neededBy, {
          2: [1],
          3: [2, 1],
          4: [3, 2, 1],
          5: [4, 3, 2, 1],
          6: [5, 4, 3, 2, 1],
          7: [6, 5, 4, 3, 2, 1],
          8: [7, 6, 5, 4, 3, 2, 1]
        });
      },
      add: function add(needer, needie, negated) {
        var r = this;
        if (!(needer in r.needs)) r.needs[needer] = [];
        if (!(needie in r.neededBy)) r.neededBy[needie] = []; // // [].concat.apply(r.needs[needer], [needie], r.needs[needie]). emitted only last element

        r.needs[needer] = r.needs[needer].concat([needie], r.needs[needie]).filter(function (el, ord, l) {
          return el !== undefined && l.indexOf(el) === ord;
        }); // // [].concat.apply(r.neededBy[needie], [needer], r.neededBy[needer]). emitted only last element

        r.neededBy[needie] = r.neededBy[needie].concat([needer], r.neededBy[needer]).filter(function (el, ord, l) {
          return el !== undefined && l.indexOf(el) === ord;
        });
        if (needer in this.neededBy) this.neededBy[needer].forEach(function (e) {
          r.needs[e] = r.needs[e].concat([needie], r.needs[needie]).filter(function (el, ord, l) {
            return el !== undefined && l.indexOf(el) === ord;
          });
        });
        if (needie in this.needs) this.needs[needie].forEach(function (e) {
          r.neededBy[e] = r.neededBy[e].concat([needer], r.neededBy[needer]).filter(function (el, ord, l) {
            return el !== undefined && l.indexOf(el) === ord;
          });
        }); // this.neededBy[needie].push(needer);

        if (r.needs[needer].indexOf(needer) !== -1) r.inCycle = r.inCycle.concat(r.needs[needer]);
      },
      trim: function trim() {
        function _trim(a) {
          // filter(function (el, ord, l) { return l.indexOf(el) === ord; })
          for (var i = a.length - 1; i > -1; --i) {
            if (a.indexOf(a[i]) < i) a.splice(i, i + 1);
          }
        }

        for (k in this.needs) {
          _trim(this.needs[k]);
        }

        for (k in this.neededBy) {
          _trim(this.neededBy[k]);
        }
      },
      foundIn: {},
      addIn: function addIn(tripleExpr, shapeExpr) {
        this.foundIn[tripleExpr] = shapeExpr;
      }
    };
  }), _defineProperty(_ShExUtil2, "nestShapes", function nestShapes(schema) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ShExUtil = this;

    var index = schema._index || this.index(schema);

    if (!('no' in options)) {
      options.no = false;
    }

    var shapeLabels = Object.keys(index.shapeExprs || []);
    var shapeReferences = {};
    shapeLabels.forEach(function (label) {
      var shape = index.shapeExprs[label];
      noteReference(label, null); // just note the shape so we have a complete list at the end

      shape = _ShExUtil.skipDecl(shape);

      if (shape.type === 'Shape') {
        if ('extends' in shape) {
          shape.extends.forEach( // !!! assumes simple reference, not e.g. AND
          function (parent) {
            return noteReference(parent, shape);
          });
        }

        if ('expression' in shape) {
          (_ShExUtil.simpleTripleConstraints(shape) || []).forEach(function (tc) {
            var target = _ShExUtil.getValueType(tc.valueExpr, true);

            noteReference(target, {
              type: 'tc',
              shapeLabel: label,
              tc: tc
            });
          });
        }
      } else if (shape.type === 'NodeConstraint') {// can't have any refs to other shapes
      } else {
        throw Error('nestShapes currently only supports Shapes and NodeConstraints');
      }
    });
    var nestables = Object.keys(shapeReferences).filter(function (label) {
      return shapeReferences[label].length === 1 && shapeReferences[label][0].type === 'tc' // no inheritance support yet
      && _ShExUtil.skipDecl(index.shapeExprs[label]).type === 'Shape';
    } // Don't nest e.g. valuesets for now
    ).filter(function (nestable) {
      return !('noNestPattern' in options) || !nestable.match(RegExp(options.noNestPattern));
    }).reduce(function (acc, label) {
      acc[label] = {
        referrer: shapeReferences[label][0].shapeLabel,
        predicate: shapeReferences[label][0].tc.predicate
      };
      return acc;
    }, {});

    if (!options.no) {
      var oldToNew = {};

      if (options.rename) {
        if (!('transform' in options)) {
          options.transform = function () {
            var map = shapeLabels.reduce(function (acc, k, idx) {
              acc[k] = '_:transformed' + idx;
              return acc;
            }, {});
            return function (id, shapeExpr) {
              return map[id];
            };
          }();
        }

        Object.keys(nestables).forEach(function (oldName) {
          var shapeExpr = index.shapeExprs[oldName];
          var newName = options.transform(oldName, shapeExpr);
          oldToNew[oldName] = newName;
          shapeLabels[shapeLabels.indexOf(oldName)] = newName;
          nestables[newName] = nestables[oldName];
          nestables[newName].was = oldName;
          delete nestables[oldName];
          index.shapeExprs[newName] = index.shapeExprs[oldName];
          delete index.shapeExprs[oldName];

          if (shapeReferences[oldName].length !== 1) {
            throw Error('assertion: ' + oldName + ' doesn\'t have one reference: [' + shapeReferences[oldName] + ']');
          }

          var ref = shapeReferences[oldName][0];

          if (ref.type === 'tc') {
            if (ref.tc.valueExpr.type === 'ShapeRef') {
              ref.tc.valueExpr.reference = newName;
            } else {
              throw Error('assertion: rename not implemented for TripleConstraint expr: ' + ref.tc.valueExpr); // _ShExUtil.setValueType(ref, newName)
            }
          } else if (ref.type === 'Shape') {
            throw Error('assertion: rename not implemented for Shape: ' + ref);
          } else {
            throw Error('assertion: ' + ref.type + ' not TripleConstraint or Shape');
          }
        });
        Object.keys(nestables).forEach(function (k) {
          var n = nestables[k];

          if (n.referrer in oldToNew) {
            n.newReferrer = oldToNew[n.referrer];
          }
        }); // Restore old order for more concise diffs.

        var shapesCopy = {};
        shapeLabels.forEach(function (label) {
          return shapesCopy[label] = index.shapeExprs[label];
        });
        index.shapeExprs = shapesCopy;
      } else {
        var doomed = [];
        var ids = schema.shapes.map(function (s) {
          return s.id;
        });
        Object.keys(nestables).forEach(function (oldName) {
          shapeReferences[oldName][0].tc.valueExpr = index.shapeExprs[oldName].shapeExpr;
          var delme = ids.indexOf(oldName);
          if (schema.shapes[delme].id !== oldName) throw Error('assertion: found ' + schema.shapes[delme].id + ' instead of ' + oldName);
          doomed.push(delme);
          delete index.shapeExprs[oldName];
        });
        doomed.sort(function (l, r) {
          return r - l;
        }).forEach(function (delme) {
          var id = schema.shapes[delme].id;
          if (!nestables[id]) throw Error('deleting unexpected shape ' + id);
          schema.shapes.splice(delme, 1);
        });
      }
    } // console.dir(nestables)
    // console.dir(shapeReferences)


    return nestables;

    function noteReference(id, reference) {
      if (!(id in shapeReferences)) {
        shapeReferences[id] = [];
      }

      if (reference) {
        shapeReferences[id].push(reference);
      }
    }
  }), _defineProperty(_ShExUtil2, "getPredicateUsage", function getPredicateUsage(schema) {
    var untyped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ShExUtil = this; // populate shapeHierarchy


    var shapeHierarchy = Hierarchy.create();
    Object.keys(schema.shapes).forEach(function (label) {
      var shapeExpr = _ShExUtil.skipDecl(schema.shapes[label]);

      if (shapeExpr.type === 'Shape') {
        (shapeExpr.extends || []).forEach(function (superShape) {
          return shapeHierarchy.add(superShape.reference, label);
        });
      }
    });
    Object.keys(schema.shapes).forEach(function (label) {
      if (!(label in shapeHierarchy.parents)) shapeHierarchy.parents[label] = [];
    });
    var predicates = {}; // IRI->{ uses: [shapeLabel], commonType: shapeExpr }

    Object.keys(schema.shapes).forEach(function (shapeLabel) {
      var shapeExpr = _ShExUtil.skipDecl(schema.shapes[shapeLabel]);

      if (shapeExpr.type === 'Shape') {
        var tcs = _ShExUtil.simpleTripleConstraints(shapeExpr) || [];
        tcs.forEach(function (tc) {
          var newType = _ShExUtil.getValueType(tc.valueExpr);

          if (!(tc.predicate in predicates)) {
            predicates[tc.predicate] = {
              uses: [shapeLabel],
              commonType: newType,
              polymorphic: false
            };

            if (typeof newType === 'object') {
              untyped[tc.predicate] = {
                shapeLabel: shapeLabel,
                predicate: tc.predicate,
                newType: newType,
                references: []
              };
            }
          } else {
            predicates[tc.predicate].uses.push(shapeLabel);
            var curType = predicates[tc.predicate].commonType;

            if (typeof curType === 'object' || curType === null) {
              // another use of a predicate with no commonType
              // console.warn(`${shapeLabel} ${tc.predicate}:${newType} uses untypable predicate`)
              untyped[tc.predicate].references.push({
                shapeLabel: shapeLabel,
                newType: newType
              });
            } else if (typeof newType === 'object') {
              // first use of a predicate with no detectable commonType
              predicates[tc.predicate].commonType = null;
              untyped[tc.predicate] = {
                shapeLabel: shapeLabel,
                predicate: tc.predicate,
                curType: curType,
                newType: newType,
                references: []
              };
            } else if (curType === newType) {
              ; // same type again
            } else if (shapeHierarchy.parents[curType] && shapeHierarchy.parents[curType].indexOf(newType) !== -1) {
              predicates[tc.predicate].polymorphic = true; // already covered by current commonType
            } else {
              var idx = shapeHierarchy.parents[newType] ? shapeHierarchy.parents[newType].indexOf(curType) : -1;

              if (idx === -1) {
                var intersection = shapeHierarchy.parents[curType] ? shapeHierarchy.parents[curType].filter(function (lab) {
                  return -1 !== shapeHierarchy.parents[newType].indexOf(lab);
                }) : [];

                if (intersection.length === 0) {
                  untyped[tc.predicate] = {
                    shapeLabel: shapeLabel,
                    predicate: tc.predicate,
                    curType: curType,
                    newType: newType,
                    references: []
                  }; // console.warn(`${shapeLabel} ${tc.predicate} : ${newType} isn\'t related to ${curType}`)

                  predicates[tc.predicate].commonType = null;
                } else {
                  predicates[tc.predicate].commonType = intersection[0];
                  predicates[tc.predicate].polymorphic = true;
                }
              } else {
                predicates[tc.predicate].commonType = shapeHierarchy.parents[newType][idx];
                predicates[tc.predicate].polymorphic = true;
              }
            }
          }
        });
      }
    });
    return predicates;
  }), _defineProperty(_ShExUtil2, "simpleTripleConstraints", function simpleTripleConstraints(shape) {
    if (!('expression' in shape)) {
      return [];
    }

    if (shape.expression.type === 'TripleConstraint') {
      return [shape.expression];
    }

    if (shape.expression.type === 'EachOf' && !shape.expression.expressions.find(function (expr) {
      return expr.type !== 'TripleConstraint';
    })) {
      return shape.expression.expressions;
    }

    throw Error('can\'t (yet) express ' + JSON.stringify(shape));
  }), _defineProperty(_ShExUtil2, "skipDecl", function skipDecl(shapeExpr) {
    return shapeExpr.type === 'ShapeDecl' ? shapeExpr.shapeExpr : shapeExpr;
  }), _defineProperty(_ShExUtil2, "getValueType", function getValueType(valueExpr) {
    if (typeof valueExpr === 'string') {
      return valueExpr;
    }

    if (valueExpr.reference) {
      return valueExpr.reference;
    }

    if (valueExpr.nodeKind === 'iri') {
      return OWL.Thing;
    } // !! push this test to callers


    if (valueExpr.datatype) {
      return valueExpr.datatype;
    } // if (valueExpr.extends && valueExpr.extends.length === 1) { return valueExpr.extends[0] }


    return valueExpr; // throw Error('no value type for ' + JSON.stringify(valueExpr))
  }), _defineProperty(_ShExUtil2, "getDependencies", function getDependencies(schema, ret) {
    ret = ret || this.BiDiClosure();
    (schema.shapes || []).forEach(function (shape) {
      function _walkShapeExpression(shapeExpr, negated) {
        if (typeof shapeExpr === "string") {
          // ShapeRef
          ret.add(shape.id, shapeExpr);
        } else if (shapeExpr.type === "ShapeOr" || shapeExpr.type === "ShapeAnd") {
          shapeExpr.shapeExprs.forEach(function (expr) {
            _walkShapeExpression(expr, negated);
          });
        } else if (shapeExpr.type === "ShapeNot") {
          _walkShapeExpression(shapeExpr.shapeExpr, negated ^ 1); // !!! test negation

        } else if (shapeExpr.type === "Shape") {
          _walkShape(shapeExpr, negated);
        } else if (shapeExpr.type === "NodeConstraint") {// no impact on dependencies
        } else if (shapeExpr.type === "ShapeExternal") {} else throw Error("expected Shape{And,Or,Ref,External} or NodeConstraint in " + JSON.stringify(shapeExpr));
      }

      function _walkShape(shape, negated) {
        function _walkTripleExpression(tripleExpr, negated) {
          function _exprGroup(exprs, negated) {
            exprs.forEach(function (nested) {
              _walkTripleExpression(nested, negated); // ?? negation allowed?

            });
          }

          function _walkTripleConstraint(tc, negated) {
            if (tc.valueExpr) _walkShapeExpression(tc.valueExpr, negated);
            if (negated && ret.inCycle.indexOf(shape.id) !== -1) // illDefined/negatedRefCycle.err
              throw Error("Structural error: " + shape.id + " appears in negated cycle");
          }

          if (typeof tripleExpr === "string") {
            // Inclusion
            ret.add(shape.id, tripleExpr);
          } else {
            if ("id" in tripleExpr) ret.addIn(tripleExpr.id, shape.id);

            if (tripleExpr.type === "TripleConstraint") {
              _walkTripleConstraint(tripleExpr, negated);
            } else if (tripleExpr.type === "OneOf" || tripleExpr.type === "EachOf") {
              _exprGroup(tripleExpr.expressions);
            } else {
              throw Error("expected {TripleConstraint,OneOf,EachOf,Inclusion} in " + tripleExpr);
            }
          }
        }

        ["extends", "restricts"].forEach(function (attr) {
          if (shape[attr] && shape[attr].length > 0) shape[attr].forEach(function (i) {
            ret.add(shape.id, i);
          });
        });
        if (shape.expression) _walkTripleExpression(shape.expression, negated);
      }

      if (shape.type === "ShapeDecl") shape = shape.shapeExpr;

      _walkShapeExpression(shape, 0); // 0 means false for bitwise XOR

    });
    return ret;
  }), _defineProperty(_ShExUtil2, "partition", function partition(schema, includes, deps, cantFind) {
    var inputIndex = schema._index || this.index(schema);
    var outputIndex = {
      shapeExprs: new Map(),
      tripleExprs: new Map()
    };
    includes = includes instanceof Array ? includes : [includes]; // build dependency tree if not passed one

    deps = deps || this.getDependencies(schema);

    cantFind = cantFind || function (what, why) {
      throw new Error("Error: can't find shape " + (why ? why + " dependency " + what : what));
    };

    var partition = {};

    for (var k in schema) {
      partition[k] = k === "shapes" ? [] : schema[k];
    }

    includes.forEach(function (i) {
      if (i in outputIndex.shapeExprs) {// already got it.
      } else if (i in inputIndex.shapeExprs) {
        var adding = inputIndex.shapeExprs[i];
        partition.shapes.push(adding);
        outputIndex.shapeExprs[adding.id] = adding;
        if (i in deps.needs) deps.needs[i].forEach(function (n) {
          // Turn any needed TE into an SE.
          if (n in deps.foundIn) n = deps.foundIn[n];

          if (n in outputIndex.shapeExprs) {} else if (n in inputIndex.shapeExprs) {
            var needed = inputIndex.shapeExprs[n];
            partition.shapes.push(needed);
            outputIndex.shapeExprs[needed.id] = needed;
          } else cantFind(n, i);
        });
      } else {
        cantFind(i, "supplied");
      }
    });
    return partition;
  }), _defineProperty(_ShExUtil2, "flatten", function flatten(schema, deps, cantFind) {
    var v = this.Visitor();
    return v.visitSchema(schema);
  }), _defineProperty(_ShExUtil2, "emptySchema", function emptySchema() {
    return {
      type: "Schema"
    };
  }), _defineProperty(_ShExUtil2, "merge", function merge(left, right, overwrite, inPlace) {
    var ret = inPlace ? left : this.emptySchema();

    function mergeArray(attr) {
      Object.keys(left[attr] || {}).forEach(function (key) {
        if (!(attr in ret)) ret[attr] = {};
        ret[attr][key] = left[attr][key];
      });
      Object.keys(right[attr] || {}).forEach(function (key) {
        if (!(attr in left) || !(key in left[attr]) || overwrite) {
          if (!(attr in ret)) ret[attr] = {};
          ret[attr][key] = right[attr][key];
        }
      });
    }

    function mergeMap(attr) {
      (left[attr] || new Map()).forEach(function (value, key, map) {
        if (!(attr in ret)) ret[attr] = new Map();
        ret[attr].set(key, left[attr].get(key));
      });
      (right[attr] || new Map()).forEach(function (value, key, map) {
        if (!(attr in left) || !left[attr].has(key) || overwrite) {
          if (!(attr in ret)) ret[attr] = new Map();
          ret[attr].set(key, right[attr].get(key));
        }
      });
    } // base


    if ("_base" in left) ret._base = left._base;
    if ("_base" in right) if (!("_base" in left) || overwrite) ret._base = right._base;
    mergeArray("_prefixes");
    mergeMap("_sourceMap");
    if ("imports" in right) if (!("imports" in left) || overwrite) ret.imports = right.imports; // startActs

    if ("startActs" in left) ret.startActs = left.startActs;
    if ("startActs" in right) if (!("startActs" in left) || overwrite) ret.startActs = right.startActs; // start

    if ("start" in left) ret.start = left.start;
    if ("start" in right) if (!("start" in left) || overwrite) ret.start = right.start;
    var lindex = left._index || this.index(left); // shapes

    if (!inPlace) (left.shapes || []).forEach(function (lshape) {
      if (!("shapes" in ret)) ret.shapes = [];
      ret.shapes.push(lshape);
    });
    (right.shapes || []).forEach(function (rshape) {
      if (!("shapes" in left) || !(rshape.id in lindex.shapeExprs) || overwrite) {
        if (!("shapes" in ret)) ret.shapes = [];
        ret.shapes.push(rshape);
      }
    });
    if (left._index || right._index) ret._index = this.index(ret); // inefficient; could build above

    return ret;
  }), _defineProperty(_ShExUtil2, "absolutizeResults", function absolutizeResults(parsed, base) {
    // !! duplicate of Validation-test.js:84: var referenceResult = parseJSONFile(resultsFile...)
    function mapFunction(k, obj) {
      // resolve relative URLs in results file
      if (["shape", "reference", "node", "subject", "predicate", "object"].indexOf(k) !== -1 && RdfTerm.isIRI(obj[k])) {
        obj[k] = RdfTerm.resolveRelativeIRI(base, obj[k]);
      }
    }

    function resolveRelativeURLs(obj) {
      Object.keys(obj).forEach(function (k) {
        if (typeof obj[k] === "object") {
          resolveRelativeURLs(obj[k]);
        }

        if (mapFunction) {
          mapFunction(k, obj);
        }
      });
    }

    resolveRelativeURLs(parsed);
    return parsed;
  }), _defineProperty(_ShExUtil2, "getProofGraph", function getProofGraph(res, db, dataFactory) {
    function _dive1(solns) {
      if (solns.type === "NodeTest" || solns.type === "NodeConstraintTest") {} else if (solns.type === "SolutionList" || solns.type === "ShapeAndResults") {
        solns.solutions.forEach(function (s) {
          if (s.solution) // no .solution for <S> {}
            _dive1(s.solution);
        });
      } else if (solns.type === "ShapeOrResults") {
        _dive1(solns.solution);
      } else if (solns.type === "ShapeTest") {
        if ("solution" in solns) _dive1(solns.solution);
      } else if (solns.type === "OneOfSolutions" || solns.type === "EachOfSolutions") {
        solns.solutions.forEach(function (s) {
          _dive1(s);
        });
      } else if (solns.type === "OneOfSolution" || solns.type === "EachOfSolution") {
        solns.expressions.forEach(function (s) {
          _dive1(s);
        });
      } else if (solns.type === "TripleConstraintSolutions") {
        solns.solutions.map(function (s) {
          if (s.type !== "TestedTriple") throw Error("unexpected result type: " + s.type);
          var s2 = s;
          if (typeof s2.object === "object") s2.object = "\"" + s2.object.value.replace(/"/g, "\\\"") + "\"" + (s2.object.language ? "@" + s2.object.language : s2.object.type ? "^^" + s2.object.type : "");
          db.addQuad(RdfTerm.externalTriple(s2, dataFactory));

          if ("referenced" in s) {
            _dive1(s.referenced);
          }
        });
      } else {
        throw Error("unexpected expr type " + solns.type + " in " + JSON.stringify(solns));
      }
    }

    _dive1(res);

    return db;
  }), _defineProperty(_ShExUtil2, "validateSchema", function validateSchema(schema) {
    // obselete, but may need other validations in the future.
    var _ShExUtil = this;

    var visitor = this.Visitor();
    var currentLabel = currentExtra = null;
    var currentNegated = false;
    var dependsOn = {};
    var inTE = false;
    var oldVisitShape = visitor.visitShape;
    var negativeDeps = Hierarchy.create();
    var positiveDeps = Hierarchy.create();
    var index = schema.index || this.index(schema);

    visitor.visitShape = function (shape, label) {
      var lastExtra = currentExtra;
      currentExtra = shape.extra;
      var ret = oldVisitShape.call(visitor, shape, label);
      currentExtra = lastExtra;
      return ret;
    };

    var oldVisitShapeNot = visitor.visitShapeNot;

    visitor.visitShapeNot = function (shapeNot, label) {
      var lastNegated = currentNegated;
      currentNegated ^= true;
      var ret = oldVisitShapeNot.call(visitor, shapeNot, label);
      currentNegated = lastNegated;
      return ret;
    };

    var oldVisitTripleConstraint = visitor.visitTripleConstraint;

    visitor.visitTripleConstraint = function (expr) {
      var lastNegated = currentNegated;
      if (currentExtra && currentExtra.indexOf(expr.predicate) !== -1) currentNegated ^= true;
      inTE = true;
      var ret = oldVisitTripleConstraint.call(visitor, expr);
      inTE = false;
      currentNegated = lastNegated;
      return ret;
    };

    var oldVisitShapeRef = visitor.visitShapeRef;

    visitor.visitShapeRef = function (shapeRef) {
      if (!(shapeRef in index.shapeExprs)) throw firstError(Error("Structural error: reference to " + JSON.stringify(shapeRef) + " not found in schema shape expressions:\n" + dumpKeys(index.shapeExprs) + "."), shapeRef);
      if (!inTE && shapeRef === currentLabel) throw firstError(Error("Structural error: circular reference to " + currentLabel + "."), shapeRef);
      (currentNegated ? negativeDeps : positiveDeps).add(currentLabel, shapeRef);
      return oldVisitShapeRef.call(visitor, shapeRef);
    };

    var oldVisitInclusion = visitor.visitInclusion;

    visitor.visitInclusion = function (inclusion) {
      var refd;
      if (!(refd = index.tripleExprs[inclusion])) throw firstError(Error("Structural error: included shape " + inclusion + " not found in schema triple expressions:\n" + dumpKeys(index.tripleExprs) + "."), inclusion); // if (refd.type !== "Shape")
      //   throw Error("Structural error: " + inclusion + " is not a simple shape.");

      return oldVisitInclusion.call(visitor, inclusion);
    };

    (schema.shapes || []).forEach(function (shape) {
      currentLabel = shape.id;
      visitor.visitShapeDecl(shape, shape.id);
    });
    var circs = Object.keys(negativeDeps.children).filter(function (k) {
      return negativeDeps.children[k].filter(function (k2) {
        return k2 in negativeDeps.children && negativeDeps.children[k2].indexOf(k) !== -1 || k2 in positiveDeps.children && positiveDeps.children[k2].indexOf(k) !== -1;
      }).length > 0;
    });
    if (circs.length) throw firstError(Error("Structural error: circular negative dependencies on " + circs.join(',') + "."), circs[0]);

    function dumpKeys(obj) {
      return obj ? Object.keys(obj).map(function (u) {
        return u.substr(0, 2) === '_:' ? u : '<' + u + '>';
      }).join("\n        ") : '- none defined -';
    }

    function firstError(e, obj) {
      if ("_sourceMap" in schema) e.location = (schema._sourceMap.get(obj) || [undefined])[0];
      return e;
    }
  }), _defineProperty(_ShExUtil2, "isWellDefined", function isWellDefined(schema) {
    this.validateSchema(schema); // var deps = this.getDependencies(schema);

    return schema;
  }), _defineProperty(_ShExUtil2, "walkVal", function walkVal(val, cb) {
    var _ShExUtil = this;

    if (val.type === "NodeTest") {
      return null;
    } else if (val.type === "ShapeTest") {
      return "solution" in val ? _ShExUtil.walkVal(val.solution, cb) : null;
    } else if (val.type === "ShapeOrResults") {
      return _ShExUtil.walkVal(val.solution || val.solutions, cb);
    } else if (val.type === "ShapeAndResults") {
      return val.solutions.reduce(function (ret, exp) {
        var n = _ShExUtil.walkVal(exp, cb);

        if (n) Object.keys(n).forEach(function (k) {
          if (k in ret) ret[k] = ret[k].concat(n[k]);else ret[k] = n[k];
        });
        return ret;
      }, {});
    } else if (val.type === "EachOfSolutions" || val.type === "OneOfSolutions") {
      return val.solutions.reduce(function (ret, sln) {
        sln.expressions.forEach(function (exp) {
          var n = _ShExUtil.walkVal(exp, cb);

          if (n) Object.keys(n).forEach(function (k) {
            if (k in ret) ret[k] = ret[k].concat(n[k]);else ret[k] = n[k];
          });
        });
        return ret;
      }, {});
    } else if (val.type === "OneOfSolutions") {
      return val.solutions.reduce(function (ret, sln) {
        Object.assign(ret, _ShExUtil.walkVal(sln, cb));
        return ret;
      }, {});
    } else if (val.type === "TripleConstraintSolutions") {
      if ("solutions" in val) {
        var ret = {};
        var vals = [];
        ret[val.predicate] = vals;
        val.solutions.forEach(function (sln) {
          var toAdd = [];

          if (chaseList(sln.referenced, toAdd)) {
            vals = vals.concat(toAdd);
          } else {
            var newElt = cb(sln);

            if ("referenced" in sln) {
              var t = _ShExUtil.walkVal(sln.referenced, cb);

              if (t) newElt.nested = t;
            }

            vals.push(newElt);
          }

          function chaseList(li) {
            if (!li) return false;
            if (li.node === RDF.nil) return true;

            if ("solution" in li && "solutions" in li.solution && li.solution.solutions.length === 1 && "expressions" in li.solution.solutions[0] && li.solution.solutions[0].expressions.length === 2 && "predicate" in li.solution.solutions[0].expressions[0] && li.solution.solutions[0].expressions[0].predicate === RDF.first && li.solution.solutions[0].expressions[1].predicate === RDF.rest) {
              var expressions = li.solution.solutions[0].expressions;
              var ent = expressions[0];
              var rest = expressions[1].solutions[0];
              var member = ent.solutions[0];
              var newElt = cb(member);

              if ("referenced" in member) {
                var t = _ShExUtil.walkVal(member.referenced, cb);

                if (t) newElt.nested = t;
              }

              vals.push(newElt);
              return rest.object === RDF.nil ? true : chaseList(rest.referenced.type === "ShapeOrResults" // heuristic for `nil  OR @<list>` idiom
              ? rest.referenced.solution : rest.referenced);
            }
          }
        });
        return vals.length ? ret : null;
      } else {
        return null;
      }
    } else if (val.type === "NodeConstraintTest") {
      return null;
    } else if (val.type === "Recursion") {
      return null;
    } else {
      // console.log(val);
      throw Error("unknown shapeExpression type in " + JSON.stringify(val));
    }

    return val;
  }), _defineProperty(_ShExUtil2, "valToValues", function valToValues(val) {
    return this.walkVal(val, function (sln) {
      return {
        ldterm: sln.object
      };
    });
  }), _defineProperty(_ShExUtil2, "valToExtension", function valToExtension(val, lookfor) {
    var map = this.walkVal(val, function (sln) {
      return {
        extensions: sln.extensions
      };
    });

    function extensions(obj) {
      var list = [];
      var crushed = {};

      function crush(elt) {
        if (crushed === null) return elt;

        if (elt.constructor === Array) {
          crushed = null;
          return elt;
        }

        for (k in elt) {
          if (k in crushed) {
            crushed = null;
            return elt;
          }

          crushed[k] = elt[k];
        }

        return elt;
      }

      for (var k in obj) {
        if (k === "extensions") {
          if (obj[k]) list.push(crush(obj[k][lookfor]));
        } else if (k === "nested") {
          var nested = extensions(obj[k]);
          if (nested.constructor === Array) nested.forEach(crush);else crush(nested);
          list = list.concat(nested);
        } else {
          list.push(crush(extensions(obj[k])));
        }
      }

      return list.length === 1 ? list[0] : crushed ? crushed : list;
    }

    return extensions(map);
  }), _defineProperty(_ShExUtil2, "valuesToSchema", function valuesToSchema(values) {
    // console.log(JSON.stringify(values, null, "  "));
    var v = values;
    var t = values[RDF.type][0].ldterm;

    if (t === SX.Schema) {
      /* Schema { "@context":"http://www.w3.org/ns/shex.jsonld"
       *           startActs:[SemAct+]? start:(shapeExpr|labeledShapeExpr)?
       *           shapes:[labeledShapeExpr+]? }
       */
      var ret = {
        "@context": "http://www.w3.org/ns/shex.jsonld",
        type: "Schema"
      };
      if (SX.startActs in v) ret.startActs = v[SX.startActs].map(function (e) {
        var ret = {
          type: "SemAct",
          name: e.nested[SX.name][0].ldterm
        };
        if (SX.code in e.nested) ret.code = e.nested[SX.code][0].ldterm.value;
        return ret;
      });
      if (SX.imports in v) ret.imports = v[SX.imports].map(function (e) {
        return e.ldterm;
      });
      if (values[SX.start]) ret.start = extend({
        id: values[SX.start][0].ldterm
      }, shapeExpr(values[SX.start][0].nested));
      var shapes = values[SX.shapes];

      if (shapes) {
        ret.shapes = shapes.map(function (v) {
          // @@ console.log(v.nested);
          var t = v.nested[RDF.type][0].ldterm;
          var obj = t === SX.ShapeDecl ? {
            type: SX.ShapeDecl,
            abstract: !!v.nested[SX["abstract"]][0].ldterm.value,
            shapeExpr: shapeExpr(v.nested[SX.shapeExpr][0].nested)
          } : shapeExpr(v.nested);
          return extend({
            id: v.ldterm
          }, obj);
        });
      } // console.log(ret);


      return ret;
    } else {
      throw Error("unknown schema type in " + JSON.stringify(values));
    }

    function findType(v, elts, f) {
      var t = v[RDF.type][0].ldterm.substr(SX._namespace.length);
      var elt = elts[t];
      if (!elt) return Missed;

      if (elt.nary) {
        var ret = {
          type: t
        };
        ret[elt.prop] = v[SX[elt.prop]].map(function (e) {
          return valueOf(e);
        });
        return ret;
      } else {
        var ret = {
          type: t
        };

        if (elt.prop) {
          ret[elt.prop] = valueOf(v[SX[elt.prop]][0]);
        }

        return ret;
      }

      function valueOf(x) {
        return elt.expr && "nested" in x ? extend({
          id: x.ldterm
        }, f(x.nested)) : x.ldterm;
      }
    }

    function shapeExpr(v) {
      // shapeExpr = ShapeOr | ShapeAnd | ShapeNot | NodeConstraint | Shape | ShapeRef | ShapeExternal;
      var elts = {
        "ShapeAnd": {
          nary: true,
          expr: true,
          prop: "shapeExprs"
        },
        "ShapeOr": {
          nary: true,
          expr: true,
          prop: "shapeExprs"
        },
        "ShapeNot": {
          nary: false,
          expr: true,
          prop: "shapeExpr"
        },
        "ShapeRef": {
          nary: false,
          expr: false,
          prop: "reference"
        },
        "ShapeExternal": {
          nary: false,
          expr: false,
          prop: null
        }
      };
      var ret = findType(v, elts, shapeExpr);
      if (ret !== Missed) return ret;
      var t = v[RDF.type][0].ldterm;

      if (t === SX.ShapeDecl) {
        var ret = {
          type: "ShapeDecl"
        };
        ["abstract"].forEach(function (a) {
          if (SX[a] in v) ret[a] = !!v[SX[a]][0].ldterm.value;
        });

        if (SX.shapeExpr in v) {
          ret.shapeExpr = "nested" in v[SX.shapeExpr][0] ? extend({
            id: v[SX.shapeExpr][0].ldterm
          }, shapeExpr(v[SX.shapeExpr][0].nested)) : v[SX.shapeExpr][0].ldterm;
        }

        return ret;
      } else if (t === SX.Shape) {
        var ret = {
          type: "Shape"
        };
        ["closed"].forEach(function (a) {
          if (SX[a] in v) ret[a] = !!v[SX[a]][0].ldterm.value;
        });
        ["extra", "extends", "restricts"].forEach(function (a) {
          if (SX[a] in v) ret[a] = v[SX[a]].map(function (e) {
            return e.ldterm;
          });
        });

        if (SX.expression in v) {
          ret.expression = "nested" in v[SX.expression][0] ? extend({
            id: v[SX.expression][0].ldterm
          }, tripleExpr(v[SX.expression][0].nested)) : v[SX.expression][0].ldterm;
        }

        if (SX.annotation in v) ret.annotations = v[SX.annotation].map(function (e) {
          return {
            type: "Annotation",
            predicate: e.nested[SX.predicate][0].ldterm,
            object: e.nested[SX.object][0].ldterm
          };
        });
        if (SX.semActs in v) ret.semActs = v[SX.semActs].map(function (e) {
          var ret = {
            type: "SemAct",
            name: e.nested[SX.name][0].ldterm
          };
          if (SX.code in e.nested) ret.code = e.nested[SX.code][0].ldterm.value;
          return ret;
        });
        return ret;
      } else if (t === SX.NodeConstraint) {
        var ret = {
          type: "NodeConstraint"
        };
        if (SX.values in v) ret.values = v[SX.values].map(function (v1) {
          return objectValue(v1);
        });
        if (SX.nodeKind in v) ret.nodeKind = v[SX.nodeKind][0].ldterm.substr(SX._namespace.length);
        ["length", "minlength", "maxlength", "mininclusive", "maxinclusive", "minexclusive", "maxexclusive", "totaldigits", "fractiondigits"].forEach(function (a) {
          if (SX[a] in v) ret[a] = parseFloat(v[SX[a]][0].ldterm.value);
        });
        if (SX.pattern in v) ret.pattern = v[SX.pattern][0].ldterm.value;
        if (SX.flags in v) ret.flags = v[SX.flags][0].ldterm.value;
        if (SX.datatype in v) ret.datatype = v[SX.datatype][0].ldterm;
        return ret;
      } else {
        throw Error("unknown shapeExpr type in " + JSON.stringify(v));
      }
    }

    function objectValue(v, expectString) {
      if ("nested" in v) {
        var t = v.nested[RDF.type][0].ldterm;

        if ([SX.IriStem, SX.LiteralStem, SX.LanguageStem].indexOf(t) !== -1) {
          var ldterm = v.nested[SX.stem][0].ldterm.value;
          return {
            type: t.substr(SX._namespace.length),
            stem: ldterm
          };
        } else if ([SX.Language].indexOf(t) !== -1) {
          return {
            type: "Language",
            languageTag: v.nested[SX.languageTag][0].ldterm.value
          };
        } else if ([SX.IriStemRange, SX.LiteralStemRange, SX.LanguageStemRange].indexOf(t) !== -1) {
          var st = v.nested[SX.stem][0];
          var stem = st;

          if (typeof st === "object") {
            if (typeof st.ldterm === "object") {
              stem = st.ldterm;
            } else if (st.ldterm.startsWith("_:")) {
              stem = {
                type: "Wildcard"
              };
            }
          }

          var ret = {
            type: t.substr(SX._namespace.length),
            stem: stem.type !== "Wildcard" ? stem.value : stem
          };

          if (SX.exclusion in v.nested) {
            // IriStemRange:
            // * [{"ldterm":"http://a.example/v1"},{"ldterm":"http://a.example/v3"}] <-- no value
            // * [{"ldterm":"_:b836","nested":{a:[{"ldterm":sx:IriStem}],
            //                                 sx:stem:[{"ldterm":{"value":"http://a.example/v1"}}]}},
            //    {"ldterm":"_:b838","nested":{a:[{"ldterm":sx:IriStem}],
            //                                 sx:stem:[{"ldterm":{"value":"http://a.example/v3"}}]}}]
            // LiteralStemRange:
            // * [{"ldterm":{"value":"v1"}},{"ldterm":{"value":"v3"}}]
            // * [{"ldterm":"_:b866","nested":{a:[{"ldterm":sx:LiteralStem}],
            //                                 sx:stem:[{"ldterm":{"value":"v1"}}]}},
            //    {"ldterm":"_:b868","nested":{a:[{"ldterm":sx:LiteralStem}],
            //                                 sx:stem:[{"ldterm":{"value":"v3"}}]}}]
            // LanguageStemRange:
            // * [{"ldterm":{"value":"fr-be"}},{"ldterm":{"value":"fr-ch"}}]
            // * [{"ldterm":"_:b851","nested":{a:[{"ldterm":sx:LanguageStem}],
            //                                 sx:stem:[{"ldterm":{"value":"fr-be"}}]}},
            //    {"ldterm":"_:b853","nested":{a:[{"ldterm":sx:LanguageStem}],
            //                                 sx:stem:[{"ldterm":{"value":"fr-ch"}}]}}]
            ret.exclusions = v.nested[SX.exclusion].map(function (v1) {
              return objectValue(v1, t !== SX.IriStemRange);
            });
          }

          return ret;
        } else {
          throw Error("unknown objectValue type in " + JSON.stringify(v));
        }
      } else {
        return expectString ? v.ldterm.value : v.ldterm;
      }
    }

    function tripleExpr(v) {
      // tripleExpr = EachOf | OneOf | TripleConstraint | Inclusion ;
      var elts = {
        "EachOf": {
          nary: true,
          expr: true,
          prop: "expressions"
        },
        "OneOf": {
          nary: true,
          expr: true,
          prop: "expressions"
        },
        "Inclusion": {
          nary: false,
          expr: false,
          prop: "include"
        }
      };
      var ret = findType(v, elts, tripleExpr);

      if (ret !== Missed) {
        minMaxAnnotSemActs(v, ret);
        return ret;
      }

      var t = v[RDF.type][0].ldterm;

      if (t === SX.TripleConstraint) {
        var ret = {
          type: "TripleConstraint",
          predicate: v[SX.predicate][0].ldterm
        };
        ["inverse"].forEach(function (a) {
          if (SX[a] in v) ret[a] = !!v[SX[a]][0].ldterm.value;
        });
        if (SX.valueExpr in v) ret.valueExpr = extend({
          id: v[SX.valueExpr][0].ldterm
        }, "nested" in v[SX.valueExpr][0] ? shapeExpr(v[SX.valueExpr][0].nested) : {});
        minMaxAnnotSemActs(v, ret);
        return ret;
      } else {
        throw Error("unknown tripleExpr type in " + JSON.stringify(v));
      }
    }

    function minMaxAnnotSemActs(v, ret) {
      if (SX.min in v) ret.min = parseInt(v[SX.min][0].ldterm.value);

      if (SX.max in v) {
        ret.max = parseInt(v[SX.max][0].ldterm.value);
        if (isNaN(ret.max)) ret.max = UNBOUNDED;
      }

      if (SX.annotation in v) ret.annotations = v[SX.annotation].map(function (e) {
        return {
          type: "Annotation",
          predicate: e.nested[SX.predicate][0].ldterm,
          object: e.nested[SX.object][0].ldterm
        };
      });
      if (SX.semActs in v) ret.semActs = v[SX.semActs].map(function (e) {
        var ret = {
          type: "SemAct",
          name: e.nested[SX.name][0].ldterm
        };
        if (SX.code in e.nested) ret.code = e.nested[SX.code][0].ldterm.value;
        return ret;
      });
      return ret;
    }
  }), _defineProperty(_ShExUtil2, "valToSimple", function valToSimple(val) {
    var _ShExUtil = this;

    function _join(list) {
      return list.reduce(function (ret, elt) {
        Object.keys(elt).forEach(function (k) {
          if (k in ret) {
            ret[k] = Array.from(new Set(ret[k].concat(elt[k])));
          } else {
            ret[k] = elt[k];
          }
        });
        return ret;
      }, {});
    }

    if (val.type === "TripleConstraintSolutions") {
      if ("solutions" in val) {
        return val.solutions.reduce(function (ret, sln) {
          if (!("referenced" in sln)) return {};
          var toAdd = {};

          if (chaseList(sln.referenced, toAdd)) {
            return _join(ret, toAdd);
          } else {
            return _join(ret, _ShExUtil.valToSimple(sln.referenced));
          }

          function chaseList(li) {
            if (!li) return false;
            if (li.node === RDF.nil) return true;

            if ("solution" in li && "solutions" in li.solution && li.solution.solutions.length === 1 && "expressions" in li.solution.solutions[0] && li.solution.solutions[0].expressions.length === 2 && "predicate" in li.solution.solutions[0].expressions[0] && li.solution.solutions[0].expressions[0].predicate === RDF.first && li.solution.solutions[0].expressions[1].predicate === RDF.rest) {
              var expressions = li.solution.solutions[0].expressions;
              var ent = expressions[0];
              var rest = expressions[1].solutions[0];
              var member = ent.solutions[0];
              var newElt = {
                ldterm: member.object
              };

              if ("referenced" in member) {
                var t = _ShExUtil.valToSimple(member.referenced);

                if (t) newElt.nested = t;
              }

              toAdd = _join(toAdd, newElt);
              return rest.object === RDF.nil ? true : chaseList(rest.referenced);
            }
          }
        }, []);
      } else {
        return [];
      }
    } else if (["TripleConstraintSolutions"].indexOf(val.type) !== -1) {
      return {};
    } else if (val.type === "NodeTest") {
      var thisNode = {};
      thisNode[n3ify(val.node)] = [val.shape];
      return thisNode;
    } else if (val.type === "ShapeTest") {
      var thisNode = {};
      thisNode[n3ify(val.node)] = [val.shape];
      return "solution" in val ? _join([thisNode].concat(_ShExUtil.valToSimple(val.solution))) : thisNode;
    } else if (val.type === "Recursion") {
      return {};
    } else if ("solutions" in val) {
      // ["SolutionList", "EachOfSolutions", "OneOfSolutions", "ShapeAndResults", "ShapeOrResults"].indexOf(val.type) !== -1
      return _join(val.solutions.map(function (sln) {
        return _ShExUtil.valToSimple(sln);
      }));
    } else if ("expressions" in val) {
      return _join(val.expressions.map(function (sln) {
        return _ShExUtil.valToSimple(sln);
      }));
    } else {
      // console.log(val);
      throw Error("unknown shapeExpression type in " + JSON.stringify(val));
    }

    return val;
  }), _defineProperty(_ShExUtil2, "simpleToShapeMap", function simpleToShapeMap(x) {
    return Object.keys(x).reduce(function (ret, k) {
      x[k].forEach(function (s) {
        ret.push({
          node: k,
          shape: s
        });
      });
      return ret;
    }, []);
  }), _defineProperty(_ShExUtil2, "absolutizeShapeMap", function absolutizeShapeMap(parsed, base) {
    return parsed.map(function (elt) {
      return Object.assign(elt, {
        node: RdfTerm.resolveRelativeIRI(base, elt.node),
        shape: RdfTerm.resolveRelativeIRI(base, elt.shape)
      });
    });
  }), _defineProperty(_ShExUtil2, "errsToSimple", function errsToSimple(val, node, shape) {
    var _ShExUtil = this;

    if (val.type === "FailureList") {
      return val.errors.reduce(function (ret, e) {
        return ret.concat(_ShExUtil.errsToSimple(e));
      }, []);
    } else if (val.type === "Failure") {
      return ["validating " + val.node + " as " + val.shape + ":"].concat(errorList(val.errors).reduce(function (ret, e) {
        var nested = _ShExUtil.errsToSimple(e).map(function (s) {
          return "  " + s;
        });

        return ret.length > 0 ? ret.concat(["  OR"]).concat(nested) : nested.map(function (s) {
          return "  " + s;
        });
      }, []));
    } else if (val.type === "TypeMismatch") {
      var nested = val.errors.constructor === Array ? val.errors.reduce(function (ret, e) {
        return ret.concat((typeof e === "string" ? [e] : _ShExUtil.errsToSimple(e)).map(function (s) {
          return "  " + s;
        }));
      }, []) : "  " + (typeof e === "string" ? [val.errors] : _ShExUtil.errsToSimple(val.errors));
      return ["validating " + n3ify(val.triple.object) + ":"].concat(nested);
    } else if (val.type === "RestrictionError") {
      var nested = val.errors.constructor === Array ? val.errors.reduce(function (ret, e) {
        return ret.concat((typeof e === "string" ? [e] : _ShExUtil.errsToSimple(e)).map(function (s) {
          return "  " + s;
        }));
      }, []) : "  " + (typeof e === "string" ? [val.errors] : _ShExUtil.errsToSimple(val.errors));
      return ["validating restrictions on " + n3ify(val.focus) + ":"].concat(nested);
    } else if (val.type === "ShapeAndFailure") {
      return val.errors.constructor === Array ? val.errors.reduce(function (ret, e) {
        return ret.concat((typeof e === "string" ? [e] : _ShExUtil.errsToSimple(e)).map(function (s) {
          return "  " + s;
        }));
      }, []) : "  " + (typeof e === "string" ? [val.errors] : _ShExUtil.errsToSimple(val.errors));
    } else if (val.type === "ShapeOrFailure") {
      return val.errors.constructor === Array ? val.errors.reduce(function (ret, e) {
        return ret.concat(" OR " + (typeof e === "string" ? [e] : _ShExUtil.errsToSimple(e)));
      }, []) : " OR " + (typeof e === "string" ? [val.errors] : _ShExUtil.errsToSimple(val.errors));
    } else if (val.type === "ShapeNotFailure") {
      return ["Node " + val.errors.node + " expected to NOT pass " + val.errors.shape];
    } else if (val.type === "ExcessTripleViolation") {
      return ["validating " + n3ify(val.triple.object) + ": exceeds cardinality"];
    } else if (val.type === "ClosedShapeViolation") {
      return ["ClosedShapeError: unexpected: {"].concat(val.unexpectedTriples.map(function (t) {
        return "  " + t.subject + " " + t.predicate + " " + n3ify(t.object) + " .";
      })).concat(["}"]);
    } else if (val.type === "NodeConstraintViolation") {
      var w = require("../lib/ShExWriter")();

      w._write(w._writeNodeConstraint(val.shapeExpr).join(""));

      var txt;
      w.end(function (err, res) {
        txt = res;
      });
      return ["NodeConstraintError: expected to match " + txt];
    } else if (val.type === "MissingProperty") {
      return ["Missing property: " + val.property];
    } else if (val.type === "NegatedProperty") {
      return ["Unexpected property: " + val.property];
    } else if (val.type === "AbstractShapeFailure") {
      return ["Abstract Shape: " + val.shape];
    } else if (val.constructor === Array) {
      return val.reduce(function (ret, e) {
        var nested = _ShExUtil.errsToSimple(e).map(function (s) {
          return "  " + s;
        });

        return ret.length ? ret.concat(["AND"]).concat(nested) : nested;
      }, []);
    } else {
      debugger; // console.log(val);

      throw Error("unknown shapeExpression type in " + JSON.stringify(val));
    }

    function errorList(errors) {
      return errors.reduce(function (acc, e) {
        var attrs = Object.keys(e);
        return acc.concat(attrs.length === 1 && attrs[0] === "errors" ? errorList(e.errors) : e);
      }, []);
    }
  }), _defineProperty(_ShExUtil2, "resolveRelativeIRI", RdfTerm.resolveRelativeIRI), _defineProperty(_ShExUtil2, "resolvePrefixedIRI", function resolvePrefixedIRI(prefixedIri, prefixes) {
    var colon = prefixedIri.indexOf(":");
    if (colon === -1) return null;
    var prefix = prefixes[prefixedIri.substr(0, colon)];
    return prefix === undefined ? null : prefix + prefixedIri.substr(colon + 1);
  }), _defineProperty(_ShExUtil2, "parsePassedNode", function parsePassedNode(passedValue, meta, deflt, known, reportUnknown) {
    if (passedValue === undefined || passedValue.length === 0) return known && known(meta.base) ? meta.base : deflt ? deflt() : this.NotSupplied;
    if (passedValue[0] === "_" && passedValue[1] === ":") return passedValue;

    if (passedValue[0] === "\"") {
      var m = passedValue.match(/^"((?:[^"\\]|\\")*)"(?:@(.+)|\^\^(?:<(.*)>|([^:]*):(.*)))?$/);
      if (!m) throw Error("malformed literal: " + passedValue);
      var lex = m[1],
          lang = m[2],
          rel = m[3],
          pre = m[4],
          local = m[5]; // Turn the literal into an N3.js atom.

      var quoted = "\"" + lex + "\"";
      if (lang !== undefined) return quoted + "@" + lang;

      if (pre !== undefined) {
        if (!(pre in meta.prefixes)) throw Error("error parsing node " + passedValue + " no prefix for \"" + pre + "\"");
        return quoted + "^^" + meta.prefixes[pre] + local;
      }

      if (rel !== undefined) return quoted + "^^" + RdfTerm.resolveRelativeIRI(meta.base, rel);
      return quoted;
    }

    if (!meta) return known(passedValue) ? passedValue : this.UnknownIRI;
    var relIRI = passedValue[0] === "<" && passedValue[passedValue.length - 1] === ">";
    if (relIRI) passedValue = passedValue.substr(1, passedValue.length - 2);
    var t = RdfTerm.resolveRelativeIRI(meta.base || "", passedValue); // fall back to base-less mode

    if (known(t)) return t;

    if (!relIRI) {
      var t2 = this.resolvePrefixedIRI(passedValue, meta.prefixes);
      if (t2 !== null && known(t2)) return t2;
    }

    return reportUnknown ? reportUnknown(t) : this.UnknownIRI;
  }), _defineProperty(_ShExUtil2, "executeQueryPromise", function executeQueryPromise(query, endpoint) {
    var rows;
    var queryURL = endpoint + "?query=" + encodeURIComponent(query);
    return fetch(queryURL, {
      headers: {
        'Accept': 'application/sparql-results+json'
      }
    }).then(function (resp) {
      return resp.json();
    }).then(function (t) {
      var selects = t.head.vars;
      return t.results.bindings.map(function (row) {
        return selects.map(function (sel) {
          var elt = row[sel];

          switch (elt.type) {
            case "uri":
              return elt.value;

            case "bnode":
              return "_:" + elt.value;

            case "literal":
              var datatype = elt.datatype;
              var lang = elt["xml:lang"];
              return "\"" + elt.value + "\"" + (datatype ? "^^" + datatype : lang ? "@" + lang : "");

            default:
              throw "unknown XML results type: " + elt.prop("tagName");
          }

          return row[sel];
        });
      });
    }); // .then(x => new Promise(resolve => setTimeout(() => resolve(x), 1000)));
  }), _defineProperty(_ShExUtil2, "executeQuery", function executeQuery(query, endpoint) {
    var rows, t, j;
    var queryURL = endpoint + "?query=" + encodeURIComponent(query);
    var xhr = new XMLHttpRequest();
    xhr.open("GET", queryURL, false);
    xhr.setRequestHeader('Accept', 'application/sparql-results+json');
    xhr.send(); // var selectsBlock = query.match(/SELECT\s*(.*?)\s*{/)[1];
    // var selects = selectsBlock.match(/\?[^\s?]+/g);

    var t = JSON.parse(xhr.responseText);
    var selects = t.head.vars;
    return t.results.bindings.map(function (row) {
      return selects.map(function (sel) {
        var elt = row[sel];

        switch (elt.type) {
          case "uri":
            return elt.value;

          case "bnode":
            return "_:" + elt.value;

          case "literal":
            var datatype = elt.datatype;
            var lang = elt["xml:lang"];
            return "\"" + elt.value + "\"" + (datatype ? "^^" + datatype : lang ? "@" + lang : "");

          default:
            throw "unknown XML results type: " + elt.prop("tagName");
        }

        return row[sel];
      });
    });
    /* TO ADD? XML results format parsed with jquery:
            $(data).find("sparql > results > result").
              each((_, row) => {
                rows.push($(row).find("binding > *:nth-child(1)").
                  map((idx, elt) => {
                    elt = $(elt);
                    var text = elt.text();
                    switch (elt.prop("tagName")) {
                    case "uri": return text;
                    case "bnode": return "_:" + text;
                    case "literal":
                      var datatype = elt.attr("datatype");
                      var lang = elt.attr("xml:lang");
                      return "\"" + text + "\"" + (
                        datatype ? "^^" + datatype :
                        lang ? "@" + lang :
                          "");
                    default: throw "unknown XML results type: " + elt.prop("tagName");
                    }
                  }).get());
              });
    */
  }), _defineProperty(_ShExUtil2, "makeN3DB", function makeN3DB(db, queryTracker) {
    function getSubjects() {
      return db.getSubjects().map(RdfTerm.internalTerm);
    }

    function getPredicates() {
      return db.getPredicates().map(RdfTerm.internalTerm);
    }

    function getObjects() {
      return db.getObjects().map(RdfTerm.internalTerm);
    }

    function getQuads() {
      return db.getQuads.apply(db, arguments).map(RdfTerm.internalTriple);
    }

    function getNeighborhood(point, shapeLabel
    /*, shape */
    ) {
      // I'm guessing a local DB doesn't benefit from shape optimization.
      var startTime;

      if (queryTracker) {
        startTime = new Date();
        queryTracker.start(false, point, shapeLabel);
      }

      var outgoing = db.getQuads(point, null, null, null).map(RdfTerm.internalTriple);

      if (queryTracker) {
        var time = new Date();
        queryTracker.end(outgoing, time - startTime);
        startTime = time;
      }

      if (queryTracker) {
        queryTracker.start(true, point, shapeLabel);
      }

      var incoming = db.getQuads(null, null, point, null).map(RdfTerm.internalTriple);

      if (queryTracker) {
        queryTracker.end(incoming, new Date() - startTime);
      }

      return {
        outgoing: outgoing,
        incoming: incoming
      };
    }

    return {
      // size: db.size,
      getNeighborhood: getNeighborhood,
      getSubjects: getSubjects,
      getPredicates: getPredicates,
      getObjects: getObjects,
      getQuads: getQuads,

      get size() {
        return db.size;
      } // getQuads: function (s, p, o, graph, shapeLabel) {
      //   // console.log(Error(s + p + o).stack)
      //   if (queryTracker)
      //     queryTracker.start(!!s, s ? s : o, shapeLabel);
      //   var quads = db.getQuads(s, p, o, graph)
      //   if (queryTracker)
      //     queryTracker.end(quads, new Date() - startTime);
      //   return quads;
      // }


    };
  }), _defineProperty(_ShExUtil2, "makeQueryDB", function makeQueryDB(endpoint, queryTracker) {
    var _ShExUtil = this;

    function getQuads(s, p, o, g) {
      return mapQueryToTriples("SELECT " + [s ? "" : "?s", p ? "" : "?p", o ? "" : "?o", "{", s ? s : "?s", p ? p : "?s", o ? o : "?s", "}"].join(" "), s, o);
    }

    function mapQueryToTriples(query, s, o) {
      var rows = _ShExUtil.executeQuery(query, endpoint);

      var triples = rows.map(function (row) {
        return s ? {
          subject: s,
          predicate: row[0],
          object: row[1]
        } : {
          subject: row[0],
          predicate: row[1],
          object: o
        };
      });
      return triples;
    }

    function getTripleConstraints(tripleExpr) {
      var visitor = _ShExUtil.Visitor();

      var ret = {
        out: [],
        inc: []
      };

      visitor.visitTripleConstraint = function (expr) {
        ret[expr.inverse ? "inc" : "out"].push(expr);
        return expr;
      };

      if (tripleExpr) visitor.visitExpression(tripleExpr);
      return ret;
    }

    function getNeighborhood(point, shapeLabel, shape) {
      // I'm guessing a local DB doesn't benefit from shape optimization.
      var startTime;
      var tcs = getTripleConstraints(shape.expression);
      var pz = tcs.out.map(function (t) {
        return t.predicate;
      });
      pz = pz.filter(function (p, idx) {
        return pz.lastIndexOf(p) === idx;
      });

      if (queryTracker) {
        startTime = new Date();
        queryTracker.start(false, point, shapeLabel);
      }

      var outgoing = tcs.out.length > 0 || shape.closed ? mapQueryToTriples(shape.closed ? "SELECT ?p ?o { <".concat(point, "> ?p ?o }") : "SELECT ?p ?o {\n" + pz.map(function (p) {
        return "  {<".concat(point, "> <").concat(p, "> ?o BIND(<").concat(p, "> AS ?p)}");
      }).join(" UNION\n") + "\n}", point, null) : [];

      if (queryTracker) {
        var time = new Date();
        queryTracker.end(outgoing, time - startTime);
        startTime = time;
      }

      if (queryTracker) {
        queryTracker.start(true, point, shapeLabel);
      }

      var incoming = tcs.inc.length > 0 ? mapQueryToTriples("SELECT ?s ?p { ?s ?p <".concat(point, "> }"), null, point) : [];

      if (queryTracker) {
        queryTracker.end(incoming, new Date() - startTime);
      }

      return {
        outgoing: outgoing,
        incoming: incoming
      };
    }

    return {
      getNeighborhood: getNeighborhood,
      getQuads: getQuads,
      getSubjects: function getSubjects() {
        return ["!Query DB can't index subjects"];
      },
      getPredicates: function getPredicates() {
        return ["!Query DB can't index predicates"];
      },
      getObjects: function getObjects() {
        return ["!Query DB can't index objects"];
      },

      get size() {
        return undefined;
      }

    };
  }), _defineProperty(_ShExUtil2, "makeTriplesDB", function makeTriplesDB(queryTracker) {
    var _ShExUtil = this;

    var incoming = [];
    var outgoing = [];

    function getTriplesByIRI(s, p, o, g) {
      return incoming.concat(outgoing).filter(function (t) {
        return (!s || s === t.subject) && (!p || p === t.predicate) && (!s || s === t.object);
      });
    }

    function getNeighborhood(point, shapeLabel, shape) {
      return {
        outgoing: outgoing,
        incoming: incoming
      };
    }

    return {
      getNeighborhood: getNeighborhood,
      getTriplesByIRI: getTriplesByIRI,
      getSubjects: function getSubjects() {
        return ["!Triples DB can't index subjects"];
      },
      getPredicates: function getPredicates() {
        return ["!Triples DB can't index predicates"];
      },
      getObjects: function getObjects() {
        return ["!Triples DB can't index objects"];
      },

      get size() {
        return undefined;
      },

      addIncomingTriples: function addIncomingTriples(tz) {
        Array.prototype.push.apply(incoming, tz);
      },
      addOutgoingTriples: function addOutgoingTriples(tz) {
        Array.prototype.push.apply(outgoing, tz);
      }
    };
  }), _defineProperty(_ShExUtil2, "NotSupplied", "-- not supplied --"), _defineProperty(_ShExUtil2, "UnknownIRI", "-- not found --"), _defineProperty(_ShExUtil2, "_expect", function _expect(o, p, v) {
    if (!(p in o)) this._error("expected " + JSON.stringify(o) + " to have a ." + p);
    if (arguments.length > 2 && o[p] !== v) this._error("expected " + o[o] + " to equal ." + v);
  }), _defineProperty(_ShExUtil2, "_error", function _error(str) {
    throw new Error(str);
  }), _defineProperty(_ShExUtil2, "unescapeText", function unescapeText(string, replacements) {
    var regex = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g;

    try {
      string = string.replace(regex, function (sequence, unicode4, unicode8, escapedChar) {
        var charCode;

        if (unicode4) {
          charCode = parseInt(unicode4, 16);
          if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance

          return String.fromCharCode(charCode);
        } else if (unicode8) {
          charCode = parseInt(unicode8, 16);
          if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance

          if (charCode < 0xFFFF) return String.fromCharCode(charCode);
          return String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
        } else {
          var replacement = replacements[escapedChar];
          if (!replacement) throw new Error("no replacement found for '" + escapedChar + "'");
          return replacement;
        }
      });
      return string;
    } catch (error) {
      console.warn(error);
      return '';
    }
  }), _ShExUtil2);

  function n3ify(ldterm) {
    if (typeof ldterm !== "object") return ldterm;
    var ret = "\"" + ldterm.value + "\"";
    if ("language" in ldterm) return ret + "@" + ldterm.language;
    if ("type" in ldterm) return ret + "^^" + ldterm.type;
    return ret;
  } // Add the ShExUtil functions to the given object or its prototype


  function AddShExUtil(parent, toPrototype) {
    for (var name in ShExUtil) {
      if (!toPrototype) parent[name] = ShExUtil[name];else parent.prototype[name] = ApplyToThis(ShExUtil[name]);
    }

    return parent;
  } // Returns a function that applies `f` to the `this` object


  function ApplyToThis(f) {
    return function (a) {
      return f(this, a);
    };
  }

  return AddShExUtil(AddShExUtil);
}();

if (typeof require !== 'undefined' && typeof exports !== 'undefined') module.exports = ShExUtil; // node environment